export default __webpack_public_path__ + "static/media/largeVehiclePlaceholder.68fa25db.png";